import { dataDoubleCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDoubleCircleSolid = /*#__PURE__*/createIcon(dataDoubleCircleSolid)
export default IconDoubleCircleSolid
